// Any JS that doesn't sit inside a component
import $ from 'jquery';
import AOS from 'aos';
import smoothscroll from 'smoothscroll-polyfill';
import LogRocket from 'logrocket';

$(function () {

    if (process.env.NODE_ENV === "production") {
        // LogRocket.init('ikiuzc/magic-textiles');
    }

    // Setup Animate On Scroll
    AOS.init({
        duration: 1000,
        once: true,
    });

    // Setup smooth scroll polyfill for Safari
    smoothscroll.polyfill();

    // Add class when page is scrolled
    $(window).scroll(scrollCheck);

    // Check scroll on page load
    scrollCheck();

    // Scroll to top of page
    $('.js-to-top').on('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    // Scroll to next section
    $('.js-to-next').on('click', (e) => {

        const $allButtons = $('.js-to-next');

        let scrollTo = 0;
        $allButtons.each((index, element) => {
            if (e.target === element) {
                const nextIndex = index + 1;
                const nextButton = $allButtons[nextIndex];
                scrollTo = $(nextButton).parent().offset().top;
            }
        });

        window.scrollTo({top: scrollTo, behavior: 'smooth'});

    });

    // Makes input labels float when selected
    $('.form-item--labelled input').on('focus', function() {
        $(this).parents('.form-item--labelled').addClass('active')
    });
    $('.form-item--labelled input').on('blur', function() {
        console.log('blur');
        // $(this).parents('.form-item--labelled').removeClass('active')
        if ($(this).val() === '') {
            $(this).parents('.form-item--labelled').removeClass('active')
        }
    });

    // Toggle switch class changes
    // FIXME: Event keeps firing twice on click
    $('.js-switch .switch__wrapper').on('click', () => {

        // Grab elements
        const $active = $(this).siblings('.switch__label.active');
        const $inactive = $(this).siblings('.switch__label:not(.active)');
        const $input = $(this).children('.switch__input');

        // Update values
        $input.val($inactive.attr('data-value'));

        // Update classes
        $active.removeClass('active');
        $inactive.addClass('active');

    });

    // Open Menu
    $(".js-menu-toggle").on("click", function() {
        $('.header__nav-wrap').addClass('active');
        $('.overlay').addClass('active');
        $('body').addClass('no-scroll');
    });

    // Close Menu
    $(".header__nav-close").on("click", function() {
        $('.header__nav-wrap').removeClass('active');
        $('.overlay').removeClass('active');
        $('body').removeClass('no-scroll');
    });

    // Open sub-menu panel
    $('.nav-link__icon').on('click', function() {
        $(this).parent().siblings('.nav-link__children').addClass('active');
    });

    // Close sub-menu panel
    $('.nav-link__children-close').on('click', function() {
        $(this).parent().removeClass('active');
    });

    // Jump to form
    $('[href="#form"]').on('click', function() {
       const $form = $('.cms-form-row');
       window.scrollTo({top: $form.offset().top, behavior: 'smooth'})
    });

    // Pattern 'top-level' text change
    setTimeout(() => {
        $('.pattern-widget #patternDesignBreadcrumbs > .patternDesignBreadcrumb:first-child').text('All Patterns').css('opacity', 1);
    }, 1000);

});

function scrollCheck() {
    if ($(window).scrollTop() >= 75) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
}
